const state = {
  toastConfig: {
    value: false,
    type: 'success',
    bodyText: '',
    headerText: '',
    timeout: 3000,
  },
};

const mutations = {
  setToastConfig(state, toastConfig) {
    state.toastConfig = toastConfig;
  },
};

const getters = {
  toastConfig: (state) => state.toastConfig,
};

const actions = {
  setToastConfig({ commit }, toastConfig) {
    if (process.env.NODE_ENV !== 'production' && toastConfig.headerText && !toastConfig.bodyText) {
      console.warn(
        '[ToastStore] Toast has headerText without bodyText — the header renders bold-only, which looks odd. Use bodyText for the main message instead.',
        toastConfig,
      );
    }
    commit('setToastConfig', toastConfig);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
